// extracted by mini-css-extract-plugin
module.exports = {"container":"UWV2IAZcrOMA0vUTgrwJM"};